import { BeatLinkItem } from './Beat';
import { VideoLinkItem } from './Video';
import { AudioLinkItem } from './Audio';
import { Link } from '../../core/Link';

// Export all link items
export const LinkDefinitions: Record<string, Link> = {
  'link.beat': BeatLinkItem,
  'link.video': VideoLinkItem,
  'link.audio': AudioLinkItem
};

export * from './Audio';
export * from './Beat';
export * from './Video';
export * from './Action';